export default {
  "el": {
    "colorpicker": {
      "confirm": "OK",
      "clear": "Clear"
    },
    "datepicker": {
      "now": "Now",
      "today": "Today",
      "cancel": "Cancel",
      "clear": "Clear",
      "confirm": "OK",
      "selectDate": "Select date",
      "selectTime": "Select time",
      "startDate": "Start Date",
      "startTime": "Start Time",
      "endDate": "End Date",
      "endTime": "End Time",
      "prevYear": "Previous Year",
      "nextYear": "Next Year",
      "prevMonth": "Previous Month",
      "nextMonth": "Next Month",
      "year": "",
      "month1": "January",
      "month2": "February",
      "month3": "March",
      "month4": "April",
      "month5": "May",
      "month6": "June",
      "month7": "July",
      "month8": "August",
      "month9": "September",
      "month10": "October",
      "month11": "November",
      "month12": "December",
      "week": "Week",
      "weeks": {
        "sun": "Sun",
        "mon": "Mon",
        "tue": "Tue",
        "wed": "Wed",
        "thu": "Thu",
        "fri": "Fri",
        "sat": "Sat"
      },
      "months": {
        "jan": "Jan",
        "feb": "Feb",
        "mar": "Mar",
        "apr": "Apr",
        "may": "May",
        "jun": "Jun",
        "jul": "Jul",
        "aug": "Aug",
        "sep": "Sep",
        "oct": "Oct",
        "nov": "Nov",
        "dec": "Dec"
      }
    },
    "select": {
      "loading": "Loading",
      "noMatch": "No matching data",
      "noData": "No data",
      "placeholder": "Select"
    },
    "cascader": {
      "noMatch": "No matching data",
      "loading": "Loading",
      "placeholder": "Select",
      "noData": "No data"
    },
    "pagination": {
      "goto": "Go to",
      "pagesize": "/page",
      "total": "Total {total}",
      "pageClassifier": ""
    },
    "messagebox": {
      "title": "Message",
      "confirm": "OK",
      "cancel": "Cancel",
      "error": "Illegal input"
    },
    "upload": {
      "deleteTip": "Press delete to remove",
      "delete": "Delete",
      "preview": "Preview",
      "continue": "Continue"
    },
    "table": {
      "emptyText": "No Data",
      "confirmFilter": "Confirm",
      "resetFilter": "Reset",
      "clearFilter": "All",
      "sumText": "Sum"
    },
    "tree": {
      "emptyText": "No Data"
    },
    "transfer": {
      "noMatch": "No matching data",
      "noData": "No data",
      "titles": [
        "List 1",
        "List 2"
      ],
      "filterPlaceholder": "Enter keyword",
      "noCheckedFormat": "{total} items",
      "hasCheckedFormat": "{checked}/{total} checked"
    },
    "image": {
      "error": "FAILED"
    },
    "pageHeader": {
      "title": "Back"
    },
    "popconfirm": {
      "confirmButtonText": "Yes",
      "cancelButtonText": "No"
    },
    "empty": {
      "description": "No Data"
    }
  },
  login: {
    title: "Login",
    message: "Welcome,Login Please",
    phone: "Phone NO",
    pass: "Password",
    phoneError: "Input the number",
    passError:
      "Include upper/lower letters ,numbers and special symbol with 8-64 digits",
    button: "Login",
    codeTitle: "Security verification",
    codeSuc: "Confirm",
    codeClo: "Cancel",
    codeError: "Input the code number with 6 digits",
    codeType1: "Message Authenticator code",
    codeType2: "Google Authenticator code",
    sendCode: "SMS send successfully",
    phoneLogin: "Phone login",
    emailLogin: "Email login",
    emailErr: "input the email account",
    email: "Email",
    emailCode: "Email code",
    emailSendCode: "Email code send successfully",
    codeText: "China",
  },
  header: {
    setpass: "Modify the Password",
    outLogin: "Log out",
    setPass: {
      title: "Modify the Password",
      phone: "Phone number",
      user: "user name",
      old: "Previous Password",
      oldError:
        "include upper/lower letters ,numbers and special symbol with 8-64 digits",
      new: "New Password",
      newError:
        "include upper/lower letters ,numbers and special symbol with 8-64 digits",
      com: "Confirm the new password",
      comError: "The two passwords are not the same ",
      yes: "Confirm",
      no: "Cancel",
    },
    google: {
      bind: "bind the GA",
      unBind: "unbind the GA",
      title1: "Download the GA",
      mess1: "ifind the Google Authenticator in your APP store",
      title2: "use the GA to scan the QR Code or mannual input ",
      mess2: "use the GA to scan the QR Code or mannual input ",
      copy: "Copy",
      title3: "finishing",
      mess3: "Save the secret key before you bind the GA.",
      phone: "Phone SMS code",
      google: "GA code",
      copySuccess: "Copy successfully",
      goBind: 'Go Bind',
    },
  },
  common: {
    title: "Contracts affiliate admin system",
    noData: "No data",
    noFind: "No data",
    find: "Operation",
    list: "List",
    search: "Search",
    perPage: "Per page",
    firstPage: "First page",
    prePage: "Previous page",
    nextPage: "Next Page",
    lastPage: "Last page",
    getCode: "Get code",
    geetest: "Wait for the verification",
    idType: "Item",
    noPage: "No page",
    phone: "Phone number",
    exportTit: "Export",
    download: "Download",
    export: "Export CSV",
    exportSuccess: "Export successfully",
    exportError: "Export failure",
    exportIng: "Exporting...",
    operation: "Operation",
    enter: "Please input",
    pagesTotal1: "Total:",
    pagesTotal2: "",
    save: "Save",
    cancel: "Cancel",
    alter: "Tips",
    nodata: "No data",
    sub: "Submit",
    codeSuc: "Confirm",
    query: "earch",
    add: "Add",
    newAdd: "Add",
    editor: "Edit",
    all: "All",
    del: "Delete",
    delClass: "Delete the class",
    addClass: "Add the class",
    stick: "Top",
    view: "View",
    repeal: "Cancel",
    language: "Language",
    startDate: "From date",
    endDate: "To date",
    tip: "Tip",
    continue: "Continue",
    reset: "Reset",
    chooseTip: "Choose",
    close: "Close",
    open: "Open",
    clientName: "Merchant",
    client: "Client",
    sort: "Sort",
    uid: "Uid",
    usetId: "Uid",
    symbol: "Symbol",
    type: "Type",
    time: "Create date",
    back: "Back",
    date: "Date",
    money: "Amount",
    contract: "Contract",
    contractName: "Contract name",
    systemUid: "systemUid",
    yes: "Yes",
    no: "No",
    coin: "Pair",
    delTip: "Once delete, can not find back. Continue to delete?",
    configName: "Configure name",
    success: "Success",
  },
  common_language: {
    save: "save",
    cancel: "cancel",
    sub: "submit",
    query: "search",
    uploadImg: "upload the image",
    add: "add",
    newAdd: "add",
    editor: "edit",
    del: "delete",
    delClass: "delete the class ",
    addClass: "add the class",
    stick: "top",
    view: "view",
    repeal: "cancel",
    language: "Language",
    hintImg: "Upload the image",
    chooseLanguage: "Choose one language at least",
    sortValidate: "Input a integer, larger than 1",
    hintLanguage: "Choose the language",
    startDate: "From date",
    endDate: "To date ",
    name: "Input the right name",
    china: "Chinese",
    international: "International",
    japanese: "Japanese",
    homeBoard: "Home template",
    check: "Check",
    startMinDate: "Start date must be earlier than end date",
    endMaxDate: "End date must be later than start date",
    startMinTime: "Start time must be earlier than end time",
    endMaxTime: "End time must be later than start time",
  },
  phoneCode: {
    A: [
      "Afghanistan +93+4",
      "Albania +355+8",
      "Algeria +213+12",
      "American Samoa +684+16",
      "Andorra +376+20",
      "Angola +244+24",
      "Anguilla +1264+660",
      "Antigua and Barbuda +1268+28",
      "Argentina +54+32",
      "Armenia +374+51",
      "Australia +61+36",
      "Austria +43+40",
      "Azerbaijan +994+31",
    ],
    B: [
      "Bahamas +1242+44",
      "Bahrain +973+48",
      "Bangladesh +880+50",
      "Barbados +1246+52",
      "Belarus +375+112",
      "Belgium +32+56",
      "Belize +501+84",
      "Benin +229+204",
      "Bermuda Islands +1441+60",
      "Bolivia +591+68",
      "Botswana +267+72",
      "Brazil +55+76",
      "Brunei +673+96",
      "Bulgaria +359+100",
      "Burkina Faso +226+854",
      "Burundi +257+108",
    ],
    C: [
      "Cambodia +855+116",
      "Cameroon +237+120",
      "Canada +1+124",
      "Cayman Islands +1345+136",
      "Central African Republic +236+140",
      "Chad +235+148",
      "Chile +56+152",
      "China +86+156",
      "Colombia +57+170",
      "Congo +242+178",
      "Cook Islands +682+184",
      "Costa Rica +506+188",
      "Côte d'Ivoire +225+384",
      "Cuba +53+192",
      "Cyprus +357+196",
      "Czech Republic +420+203",
    ],
    D: ["Denmark +45+208", "Djibouti +253+262", "Dominican Republic +1890+214"],
    E: [
      "Ecuador +593+218",
      "Egypt +20+818",
      "El Salvador +503+222",
      "Estonia +372+233",
      "Ethiopia +251+231",
    ],
    F: [
      "Fiji Islands +679+242",
      "Finland +358+246",
      "France +33+250",
      "French Guiana +594+254",
      "French Polynesia +689+258",
    ],
    G: [
      "Gabon +241+266",
      "Gambia +220+270",
      "Georgia +995+268",
      "Germany +49+276",
      "Ghana +233+288",
      "Gibraltar +350+292",
      "Greece +30+300",
      "Grenada +1809+308",
      "Guam +1671+316",
      "Guatemala +502+320",
      "Guinea +224+324",
      "Guyana +592+328",
    ],
    H: [
      "Haiti +509+332",
      "Honduras +504+340",
      "Hong Kong, China +852+344",
      "Hungary +36+348",
    ],
    I: [
      "Iceland +354+352",
      "India +91+356",
      "Indonesia +62+360",
      "Iran +98+364",
      "Iraq +964+368",
      "Ireland +353+372",
      "Israel +972+376",
      "Italy +39+380",
    ],
    J: ["Jamaica +1876+388", "Japan +81+392", "Jordan +962+400"],
    K: [
      "Kazakhstan +7+398",
      "Kenya +254+404",
      "North Korea +850+408",
      "South Korea +82+410",
      "Kuwait +965+414",
      "Kyrgyzstan +331+417",
    ],
    L: [
      "Laos +856+418",
      "Latvia +371+428",
      "Lebanon +961+422",
      "Lesotho +266+426",
      "Liberia +231+430",
      "Libya +218+434",
      "Liechtenstein +423+438",
      "Lithuania +370+440",
      "Luxembourg +352+442",
    ],
    M: [
      "Macau, China +853+446",
      "Madagascar +261+450",
      "Malawi +265+454",
      "Malaysia +60+458",
      "Maldives +960+462",
      "Mali +223+466",
      "Malta +356+470",
      "Martinique +596+474",
      "Mauritius +230+480",
      "Mexico +52+484",
      "Moldova +373+498",
      "Monaco +377+492",
      "Mongolia +976+496",
      "Montserrat +1664+500",
      "Morocco +212+504",
      "Mozambique +258+508",
      "Myanmar +95+104",
    ],
    N: [
      "Namibia +264+516",
      "Nauru +674+520",
      "Nepal +977+524",
      "Netherlands +31+528",
      "Netherlands Antilles +599+530",
      "New Zealand +64+554",
      "Nicaragua +505+558",
      "Niger +227+562",
      "Nigeria +234+566",
      "Norway +47+578",
    ],
    O: ["Oman +968+512"],
    P: [
      "Pakistan +92+586",
      "Panama +507+591",
      "Papua New Guinea +675+598",
      "Paraguay +595+600",
      "Peru +51+604",
      "Philippines +63+608",
      "Poland +48+616",
      "Portugal +351+620",
      "Puerto Rico +1787+630",
    ],
    Q: ["Qatar +974+634"],
    R: ["Reunion +262+638", "Romania +40+642", "Russia +7+643"],
    S: [
      "Saint Lucia +1758+662",
      "Saint Vincent and the Grenadines +1784+670",
      "Samoa +685+882",
      "San Marino +378+674",
      "Sao Tome and Principe +239+678",
      "Saudi Arabia +966+682",
      "Senegal +221+686",
      "Seychelles +248+690",
      "Sierra Leone +232+694",
      "Singapore +65+702",
      "Slovakia +421+703",
      "Slovenia +386+705",
      "Solomon Islands +677+90",
      "Somalia +252+706",
      "South Africa +27+710",
      "Spain +34+724",
      "Sri Lanka +94+144",
      "Sultan +249+736",
      "Suriname +597+740",
      "Swaziland +268+748",
      "Swedish +46+752",
      "Swiss +41+756",
      "Syria +963+760",
    ],
    T: [
      "Taiwan, China +886+158",
      "Tajikistan +992+762",
      "Tanzania +255+834",
      "Thailand +66+764",
      "Togo +228+768",
      "Tonga +676+776",
      "Trinidad and Tobago +1809+780",
      "Tunis +216+788",
      "Turkey +90+792",
      "Turkmenistan +993+795",
    ],
    U: [
      "Uganda +256+800",
      "Ukraine +380+804",
      "United Arab Emirates +971+784",
      "UK +44+826",
      "United States +1+840",
      "Uruguay +598+858",
      "Uzbekistan +233+860",
    ],
    V: ["Venezuela +58+862", "Vietnam +84+704"],
    Y: ["Yemen +967+887"],
    Z: ["Zambia +260+894", "Zimbabwe +263+716"],
  },
  roleManagement: {
    roleName: "Role name",
    rlType: "Role type",
    rlType1: "Super administrator",
    rlType2: "normal administrator",
    delTip: "Delete the role?",
    delTip1: "Delete successfully",
    roleErr: "Input the role name, 100 charactor at most",
    merchantTypeErr: "Choose the role type",
    treeData: "Privilege",
    roleText: "Role name",
    modalTitle1: "Add role",
    modalTitle2: "Edit role",
    roleText1: "Role name can be letters and numbers",
    roleRoot: "Choose the role privilege",
  },
  userManagement: {
    clientName: "Broker name",
    phone: "Phone number",
    closeGoogle: "Turn off the GA",
    loginThaw: "Login unfrozen",
    resetPassword: "Reset password",
    nickname: "Nick name",
    rlName: "Role",
    lastTime: "Last login time",
    lastIp: "Login IP",
    text: "Platform",
    modalTitle1: "Add user",
    modalTitle2: "Edit user",
    text1: "Turn off the GA or not?",
    text2: "Once delete the data,can not retrieve,continue?",
    unlockAccount: "Login unfrozen successfully",
    text3: "Continue to reset password?",
    email: "Email",
    clientNameEmpty: "Choose the broker",
    userNameEmpty: "Input the nick name",
    userNameErr: "Input the nick name,numbers,English or Chinese letters",
    phoneEmpty: "Iuput phone number",
    emailEmpty: "Input the email",
    emailErr: "Input the right email form",
    loginPwdEmpty: "Input the login password",
    loginPwdErr:
      "Input the Upper ,lower letters, numbers and special symbol with 8-64 digits",
    roleEmpty: "Choose the role",
  },
  userRoleManage: {
    del: "Relieve and delete",
    roleName: "Role name",
    roleNameTip: "100 charactors at most",
    text: "Functions restricted",
    text1:
      "Leverage level(keeping it empty means no leverage level restricted)",
    marginModel: "Margin mode",
    contractId: "Trading contracts available",
    roleNameEmpty: "Input role name",
    roleNameErr: "Input role name,Chinese,English or numbers",
    leverErr: "Max leverage level must larger than min leverage level",
    clientNameEmpty: "Choose the broker",
    text2: "No restricted",
    text3: "Isolated",
    text4: "Cross ",
    text5: "All contracts available",
    sort: "Serial numbers",
    minLever: "Min leverage level",
    maxLever: "Max leverage level",
    marginModelName: "Margin mode",
    tradeContract: "Trading contracts availableTrading contracts available",
    text6: "cross",
    text7: "isolated",
    title1: "Add role",
    title2: "Edit role",
    tip1: "Delete the role and set user to normal user ,continue?",
  },
  assetsList: {
    asset: "Asset flows",
    uid: "UID",
    totalAmount: "Total Assets",
    normalAmount: "Balance Account",
    lockAmount: "Freeze Account",
    partPositionNormal: "Isolated Margin Account",
    mtime: "Update date",
    check: "Check the user data",
    coinSymbol: "Coin",
    positionLock: "Restrictive account",
    flatAccount: "Acct balancing",
    view: "Acct balance details",
    operation: "Acct balance operation",
    txt:
      "If the balancing result is positive, it means that the funds in this account has decreased unexpectedly;If the balancing result is negative, it means that the money in this account has increased unexpectedly;",
    detail: "View details",
    manual: "Manual leveling",
    text1: "Flow type",
    text2: "Balancing income",
    text3: "Balancing expenses",
    text4: "Amount",
    text5: "Coin",
    code: "Google Verification code:",
    info: "Balancing information",
    accountLock: "Frozen margin account",
    cash: "Cash assets",
    total: "Total turnover",
    futuresIn: "Deposit",
    futuresOut: "Withdrawal",
    settlementIn: "Settlement profit",
    settlementOut: "Settlement profit/loss",
    tradeFeeIn: "Fee income",
    tradeFeeOut: "Fee expenses",
    capitalFeeIn: "Fund fee income",
    capitalFeeOut: "Fund fee expenses",
    shareAmount: "Share",
    transferIn: "Transfer income",
    transferOut: "Transfer expenses",
    flatAccountIn: "Balancing income",
    flatAccountOut: "Balancing expenses",
    error1:
      'Google verification code has not been bound yet! Please click on the avatar in the upper right corner to open the "Personal Center" for binding',
    error2: "Please enter the 6-digit Google verification code",
  },
  exportsModal: {
    text1: 'Export CSV limit',
    text2: 'Current list is {pagesTotal} rows，Up to {maxNum} rows can be exported! It is recommended to reset the conditions for batch export!',
    text3: 'Continue exporting',
  },
  transfer: {
    transferTool: "Transaction Tool",
    note: "Please use with caution!",
    title1: "system to system",
    title2: "system to user",
    title3: "user to system",
    accountType: "Account Type",
    accountBalance: "Account Balance:",
    from: "From",
    to: "To",
    transferAmount: "Amount",
    remark: "Remark",
    confirm: "Submit",
    userContractUID: "User Contract UID",
    inputUid: "Please enter correct UID",
    code: "Code",
    inputAmount: "Please enter correct transaction amount",
    notEnough: "Available balance is insufficient",
    systemAccount1: "System Recharge Account",
    systemAccount2: "Insurance funding Account",
    systemAccount3: "System Fee Account",
    userAccont1: "User Balance Account",
    userAccont2: "User Isolated Accont",
    userAccont3: "User Frozen Accont",
    warn1: "The transfer party must be a system recharge account!",
    warn2: "Transfer-in and transfer-out accounts cannot be the same!",
    warn3: "Users cannot transfer money without being bound to Google!",
    success: "Transfer Success",
    side: "Side",
    otherSideAcc: "Counterparty account",
    belongUser: "Belong to user",
    amount: "Amount",
    systemAcc: "System Account",
    outAccount: "Transfer",
    intoAccount: "Into",
    text_1: "Withdraw Fee",
    text_2:
      "Use this function to transfer all the withdraw fees of all contracts to the system recharge account to quickly collect handling fees.",
    text_3:
      'For collection records, please inquire about transfer records-the entry remarked as "Withdraw fee".',
    text_4:
      "Restrictions: Collection operations are not allowed between 23:00 and 08:00 the next day.",
    text_5: "Coin",
    text_6: "All margin coins",
    text_7: "Balance",
    text_8: "Fee accounts for all contracts",
    text_9: "Into",
    text_10: "Amount",
    text_11: "Balance",
    text_12: "Withdrawing",
    text_13: "Withdraw Fee",
    text_14: "Account numbers",
    text_15: "Successful transfer",
    text_16: "Transfer failed",
    text_17: "System recharge account",
    text_18: "Notice",
  },
  monitorModule: {
    conclusion: "Results",
    balancing: "Balancing results",
    startAssets: "Initial cash assets",
    endAssets: "Final Cash assets ",
    netInflow: "Net inflow",
    action1: "Details",
    balanceDetail: "Balancing details",
    start: "Initial",
    end: "Final",
    inGold: "Deposit",
    outGold: "Withdrawal",
    monitoringType: "Monitor type",
    monitoringState: "Monitoring status",
    cycle: "cycle",
    threshold: "Threshold",
    singleAction: "Single behavior monitor",
    cycleAction: "Cycle statistical monitor",
    singleOutAmount: "Single large withdrawal monitoring",
    singleInAmount: "Single large deposit monitoring",
    totalOutAmount: "Cumulative large withdrawal monitor",
    totalOutFrequency: "Cumulative high frequency payment monitor",
    totalInFrequency: "Cumulative frequent deposit monitor",
    userAssetGrowth: "High user asset growth monitoring",
    userAssetGrowthRate: "Monitor high growth of user assets",
    monitorAdd: "Add monitoring",
    monitorEdit: "Edit monitoring",
    monitoringSwitch: "Monitor on/off",
    error1: "Please input cycle",
    error2: "Please enter a threshold greater than 0",
    error3: "Please enter Google verification code",
    findTime: "Time",
    memo: "Abnormal content",
    balanceAmount: "Acct Balancing",
    balanceAmountUn: "Uneven",
    total: "total",
    userAssets: "User assets",
    insuranceFund: "Insurance fund",
    systemAccount: "System top-up account",
    assetsNetInflow: "Net inflow",
    googleTip: "Please bind Google captcha first",
    text1: "Reconciliation result",
    text2: "Cash assets",
    text3: "Flow Statistics",
    text4: "Total funds transferred",
    text5: "Total outgoing funds",
    action2: "Configuration",
    action3: "parameter",
  },
  followBlacklist: {
    text1: 'Blacklist Configuration',
    text2: "Please enter the UID of the user's contract account",
    text3: 'delete',
    text4: 'new',
    text5: "Please enter the UID of the user's contract account",
    text6: 'Delete Users',
    text7: 'After deleting the user, the reverse copying will start, and confirm to delete the blacklisted user',
    text8: 'Serial Number',
    text9: "The UID of the user's contract account",
  },
  delivery: {
    closingType: 'Type',
    merchantORuserID: 'Merchant ID/User ID',
    contractPair: 'Symbol',
    closeRate: 'Closing Price',
    isCancel: 'Cancel Orders',
    entrustStatus: 'Order Status',
    startTime: 'Execution Time',
    merchantIDErr0: 'Please enter the ID of the merchant contract account',
    merchantIDErr1: 'Please enter the UID of the user“s contract account',
    merchantIDErr2: "Separate two adjacent IDs with a British comma",
    merchantIDErr3: "Up to 1000 IDs can be entered",
    action: 'Execute',
    closingTypeList: ['Close a position with a merchant', "Close the user's position", 'Deliver'],
    closingPriceList: ['Market', 'Limit'],
    text1: 'The average of the mark price in the last 30 minutes',
    text2: 'Please enter the price',
    text3: 'New',
    text4: 'New',
    text5: 'Are you sure you want to cancel the setting of closing the position?',
    text6: 'Cancel',
    text7: 'Google Verification',
    statusType: ['Waiting for execution', 'In progress', 'Execution succeed', 'Failed to execute', 'Cancelled'],
    typeTxt1: 'Closed by the system',
    typeTxt2: 'Delivery',
    typeTxt3: 'Cancelled by the system'
  },

  realStatistics: {
    dateArr: ['last week', 'last month', 'last 3 months', 'last 6 months'],
    info: 'Note: The statistical data does not include the demo contract data. For contracts of different margin currencies, the transaction volume will be converted according to the exchange rate of the query, and there may be errors.',
    ttitleTxt: 'Trading volume',
    ttitleTxt1: "User's PNL",
    ttitleTxt2: 'Fund transfers in and out',
    ttitleTxt3: 'Total assets',
    exportTxt: 'Export',
    chartTxt1: "User's daily PNL",
    chartTxt2: "User's accumulated PNL",
    chartTxt3: 'Total transaction fee',
    chartTxt4: 'Total funds transferred',
    chartTxt5: 'Total outgoing funds',
    month: 'month',
    monthList: ['', 'January ', 'February', 'March ', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
  },
  "publicManage": {
    "lanset": {
      "set": "Advanced Setting",
      "addlan": "Add Language",
      "addNote": "New language template is defaulted to be English.",
      "lanList": "Language List",
      "reset": "Restore",
      "sort": "Sort",
      "fileName": "File Name",
      "resetNote": "This operation will restore the modified content to the default version. Are you sure?",
      "warn1": "Modify the content in the 'Edit Language Pack' area according to your needs;",
      "warn2": "Download the modified language pack to the local;",
      "warn3": "Upload the modified language pack, the uploaded file name should be consistent with the language file name;",
      "warn4": "%@ in the app language pack cannot be deleted, otherwise the upload will fail!",
      "warn7": "App version 5.3.3 and above supports this feature",
      "save": "Save and Download to Local System",
      "upload": "Upload",
      "return": "Return",
      "confirmLeave": "Are you sure to leave?",
      "edit": "Edit Language Pack",
      "refer": "Reference Language Pack",
      "pleaseInput": "Please enter the content of the language pack.",
      "jsonRigth": "Please enter the correct file with JSON format",
      "uploadjsonRigth": "Please upload the correct file with JSON format",
      "secound": "Please change the second line to",
      "right": "The field requires correct placeholder%@",
      "fileNameshould": "The file name should be",
      "tip": "Tips",
      "ok": "OK",
      "cancel": "Cancel",
      "modalTitle": "Are you sure you want to add a new language [{lang}]? ",
      "modalText": "Prompt: After adding, please arrange a translation in time to translate the template language into the target language? After the translation is complete, enable the language to take effect on the front end! ",
      "pause": "Disable",
      "startUse": "Enable",
      "status": "Status",
      "statusTitle": "Are you sure you want to enable (disable) the new language [{lang}]? ",
      "statusText": "Before enabling, please make sure that the translation of the affiliate system and server has been uploaded. Two sides will enable and disable this language together.",
      "admin": "Background",
      "server": "Server",
      "warn5": "Replacement character %s in the file",
      "warn6": "The code related field translation in the file can be saved without modification (these modules have other editing and modification entries in the background)",
      "btn1": "Download template file",
      "btn2": "Upload translation file",
      "updateTime": "Update Time",
      "serverUpload": "Prompt: Do not modify the template file format, do not add or modify the template file, file format: *.xlsx",
      "uploadSuccess": "Uploaded successfully",
      "tip1": "1. The new template language is English when translating!",
      "tip2": "2. When neither the new language list nor the drop-down filter exists, please contact customer service!",
      "saveSuccess": "Saved",
      "text1": "Compare&Backup",
      "text2": "Update language pack",
      "text3": "This file is a language pack, please download and translate it, and then upload it. The file name must not be changed.\nThe App only supports version 5.3.3 or above, and the %@ in the App language pack cannot be deleted, otherwise the upload will fail!",
      "text4": "Download online pack to local",
      "text5": "Only view the changed KEYs",
      "text6": "Ignore all changes",
      "text7": "Reference text",
      "text8": "Show online",
      "text10": "Changed",
      "text11": "Ignore changes",
      "text12": "If the value changes or a new KEY is added, it will be marked as \"changed\". After editing the value, the \"changed\" status will be removed. You can also manually ignore the change.",
      "text13": "Do you want to ignore all current changes?"
    },
    "basenav": {
      "title": "Bottom Navigation",
      "tabTitle1": "Footer Article",
      "tabTitle2": "Custom Footer",
      "articleTitle": "Article Title",
      "language": "Language",
      "urlName": "Article Alias",
      "sort": "Rank",
      "sortValidate": "Please enter an integer number greater than 1",
      "articleContent": "Content of the Article",
      "footerList": {
        "title": "Title",
        "fileName": "Url Title",
        "ublisher": "Publisher",
        "ctime": "Release Time",
        "sort": "Rank",
        "operation": "Operation"
      },
      "addArticle": "Adding articles",
      "editorArticle": "Editing articles",
      "hintArticleContent": "Please enter the content of the article",
      "customFooter": "whether to open custom footer"
    }
  },
  "positionList": {
    "contractId": "Contract ID",
    "uid": "Clound ID",
    "id": "Position ID",
    "status": "Position status",
    "positionType": "Margin Mode",
    "side": "Side",
    "volume": "Position",
    "closeVolume": "Position closed",
    "holdAmount": "Position Margin",
    "leverageLevel": "Leverage Level",
    "openPrice": "Average Open Price",
    "avgPrice": "Average Holding Price",
    "tagPrice": "Mark Price",
    "realizedAmount": "Realized Profit",
    "historyRealizedAmount": "Accumulated profit",
    "cTime": "Create time",
    "mTime": "Update time",
    "text1": "Holding",
    "text2": "Closed",
    "text3": "Isolated",
    "text4": "Cross",
    "text5": "Buy ",
    "text6": "Sell",
    "openTime": "Opening time",
    "sideBuy": "Buy",
    "sideSell": "Sell",
    "mtimeTip": "Whenever a position is increased or decreased, or margin is increased or decreased, it is regarded as a change.",
  },
  "entrustedList": {
    "contractId": "Contract Name",
    "type": "Order type",
    "status": "Order status",
    "tradeRecord": "Trading history",
    "uid": "UID",
    "id": "Order number",
    "status1": "Status",
    "type1": "Type",
    "open": "Position direction",
    "side": "Side",
    "volume": "Order",
    "dealVolume": "Filled order",
    "price": "Order price",
    "avgPrice": "Average price",
    "leverageLevel": "Leverage Level",
    "realizedAmount": "Profit Loss",
    "fee": "Fees",
    "marginCoin": "Margin Coin",
    "source": "Source",
    "cTime": "Create time",
    "mtime": "Update time",
    "check": "Check Data ",
    "text1": "Limit Order",
    "text2": "Market Order",
    "text3": "Initial Order",
    "text4": "New Order",
    "text5": "Full Filled",
    "text6": "Partial Filled",
    "text7": "Cancelled",
    "text8": "Cancelling",
    "text9": "Abnormal Order",
    "text10": "Unhandled abn. order",
    "text11": "Open Position",
    "text12": "Close Position",
    "text13": "Buy",
    "text14": "Sell",
    "quantity": "Quantity",
    "addText1": "The user voluntarily cancels the order",
    "addText2": "The order is abnormal and cancelled by the system",
    "addText3": "The position is liquidated, and the unfilled order is cancelled by the system",
    "addText4": "The market order has insufficient counterparty",
    "addText5": "The FOK order is cancelled by the system when it cannot be fully filled",
    "addText6": "Part of the order was cancelled by the system when the IOC order could not be executed immediately",
    "addText7": "The POST ONLY order cannot become a passive order and the system will cancel it",
    "addText8": "The position does not exist, the closing order was cancelled by the system",
    "addText9": "Liq. Order",
    "addText10": "Combined with Liq. Order",
    "addText11": "Take Profit",
    "addText12": "Stop Loss",
    "addText13": "Effective",
    "addText14": "Not Valid",
    "addText15": "Price",
    "addText16": "Order Status",
    "addText17": "Trigger Order",
    "addText18": "Take Profit/Stop Loss",
    "addText19": "Cancelled by the system",
    "addText20": "The order was canceled by the system because the position was Auto-Deleveraging (ADL)",
    "addText21": "The order was canceled by the system because the position was liquidated",
    "tabTxt15": "General Order",
    "tabTxt16": "Condition Order",
  },
  lanV4: {
    noPermissions: 'No access to this page',
    logoTxt: 'Futures admin system',
    logoTxt2: 'Futures',
    positionParam: 'Position parameters',
    viewChart: 'View chart',
    insuranceTotal: 'Total insurance funding',
    profitTotal: 'Total PNL',
    insuranceTitle: 'Insurance funding trends',
    profitTxt: 'PNL',
    filterProfitTxt: 'Total PNL within the selected date',
    loadingErr: 'Failed to load. Please',
    reset: 'Retry',
    contractID: 'Contract ID',
    closeContract: 'The contract will not be displayed on the front page after closing. Are you sure to close it?',
    openContract: 'The contract will be displayed on the front page after opening. Are you sure to open it?',
    contractStatusOpen: 'Tradable',
    contractStatusClose: 'Closed',
    contractStatusOffline: 'In delivery',
    selectCode: 'Select country code',
    reducePrice: 'Estimated liquidation price',
    completeTime: 'Complete time',
    hideAssets: 'Hide accounts with total assets of 0',
    outLogin: 'You have successfully logged out.',
    confirmDel: 'Are you sure to delete?',
    updateTime: 'Modified time',
    feeAccount: 'Fee sharing account',
    followSet: 'Copy trading configuration',
    followTip: 'Merchants will not be able to see the [Merchant Copy Trading] module in the admin system after closing.',
    followTxt: 'Merchant reverse copy trading',
    nextStep: 'Next step',
    backEnd: 'Admin system',
    transferTo: 'Transfer In',
    leveMultiple: 'Leverage level',
    basicParam: 'Basic parameters',
    otherConfig: 'Other configuration',
    btnTxt1: 'Continue to add coins',
    btnTxt2: 'Add pair',
    symbolSuccess: 'You have successfully added coins.',
    symbolSuccess2: 'You have successfully added index price.',
    btnTxt3: 'Continue adding indices',
    indexPrice: 'Index price',
    confirmClose: 'Are you sure to close?',
    confirmOpen: 'Are you sure to open?',
    priceSymbol: 'Get price pair',
    enabled: 'Opening',
    closed: 'Closed',
    contractOtherName: 'Contract alias',
    contractParam: 'Contract parameters',
    contractTab1: 'Trading opening',
    contractTab2: 'Trading closed',
    contractTab3: 'Being configured',
    paramStatus: 'Parameter status',
    release: 'Publish',
    releaseTip: 'It can be published after the parameters are completed',
    step1: 'Step1 Basic Information',
    step2: 'Step2 Rate Configuration',
    step3: 'Step3 Publish',
    chooseTep: 'Template select',
    previewLeverTitle: 'Preview leverage setting',
    previewLadderTitle: 'Preview ladder liquidation',
    choosePair: 'Choose pairs',
    prevStep: 'Previous',
    nextStep: 'Next',
    saveDraft: 'Save draft',
    directTxt: 'Direct publish',
    subjectIndex: 'Underlying pair (index)',
    pairParam: 'Pair parameters',
    addTepTxt: 'Add template',
    previewTepTxt: 'Preview configuration',
    matchTxt: 'Match settlement',
    publishParam: 'Publish parameters',
    referPrice: 'Opening reference price',
    referPriceError: 'Please enter the opening reference price.',
    priceParam: 'Price parameters',
    priceParamTip: 'This parameter will be applied to all contracts using this pair.',
    numParam: 'Quantity parameter',
    editPairTitle: 'Edit pair',
    precisionMerge: 'Oderbook depth aggregation',
    priceChange: 'Minimum price fluctuation',
    precisionMergeTip: 'Orderbook depth aggregation(up to 3 optional)',
    loading: 'Loading',
    closeContractTip: 'After closing, the user will not be able to see the contract, and the matching will be closed at the same time. Are you sure to close?',
    strongLeveWarn: 'Liquidation warning',
    draftStatus: 'Hang in the air',
    fundRateRange: 'Fund rate range',
    delContractTip: 'The information of all configurations of the contract cannot be retrieved after deletion',
    confirmRelease: 'Confirm publishing?',
    confirmReleaseTip: 'Merchants can add this contract after publishing. Are you sure you want to publish it?',
    contractTip1: 'Once created, it cannot be modified!USDⓈ-Margined Futures Contracts: Contracts with USDT as margin and settlement currency.	Coin-Margined Futures Contracts: Contracts with base currency, such as BTCUSD, and BTC, as margin and settlement currency.Hybrid Contracts: A contract with a third currency, such as BTCUSDT-EXUSD, as the margin and settlement currency.	Mock Contracts: A contract with EXUSD (analog currency) as the margin and settlement currency.',
    contractTip2: 'Once created, it cannot be modified!Please confirm that the pair has been made in [Pair]!The underlying currency pair of the Coin-M contract is XXX-USD.',
    contractTip3: 'Once created, it cannot be modified!Please confirm that this currency has been set as the margin currency!USDⓈ-M: The quote currency of [underlying currency pair].Coin-M: The underlying currency of [underlying currency pair].Coin-M: The underlying currency of [underlying currency pair].',
    contractTip4: 'Once created, it cannot be modified!The hybrid contract is a special USDⓈ-M contract, and the special feature is that the margin may not be the quote currency. But it is necessary to set a fixed exchange rate between this margin and the quote currency, meaning 1 margin = n quote currencies.',
    contractTip5: 'Once created, it cannot be modified!USDⓈ-M: The quantity of underlying currency which let it equals one contract.Coin-M: The quantity of quote currency which let it equals one contract.Hybrid: Same as USDⓈ-M.',
    contractTip6: 'The name of the contract is displayed on the client side.',
    contractTip7: "Once created, it cannot be modified!The contract ID is the unique identifier of the contract and cannot be repeated.You can add the merchant's ID to the contract ID to distinguish the contract!Such as Merchant ID-BTC-USDT",
    contractTip8: 'Use the "Start time point" and "Frequency" to determine at which time of day the funding fee will be settled.',
    contractTip9: 'Use the "Start time point" and "Frequency" to determine at which time of day the funding fee will be settled.',
    contractTip10: 'The interest determines the basic funding rate. When the market is stable, the funding rate will be at this value.',
    contractTip11: 'Used to calculate shock prices. The position to which the price would be raised or lowered if such a large amount was bought or sold at the opening. Used to measure the depth and price deviation of the market.Please note: For inverse contracts, the unit of the parameter is the underlying currency such as BTC, ETH, etc.',
    contractTip20: 'The merchant must set a Taker fee that is not lower than this value',
    contractTip21: 'The Maker service fee set by the merchant must not be lower than this value',
    contractTip22: 'How often profit and loss are realized. The timed settlement will settle the unrealized profit and loss into realized profit and loss and transfer it to the corresponding account to improve the utilization rate of funds.',
    contractTip23: 'Insurance fund compensation amount = min(Closed position loss * insurance fund compensation ratio, the remaining amount of insurance fund), the smaller the insurance fund compensation ratio, the smaller the insurance fund compensation amount of the platform after the liquidation occurs.',
    contractTip24: 'Early warning margin rate = maintenance margin rate * (1+ early warning coefficient) + taker fee rate',
    contractTip25: 'Please enter the matching server address to join. If you are not sure, please contact Ops.Please allocate server resources reasonably.',
    contractTip26: 'Please enter the matching-settlement node to join. If you are not sure, please contact Ops.Please allocate server resources reasonably.',
    contractTip27: 'Initial price at market opening. It will be displayed on the K-line, so please be set to the latest price at the time of publication!',
    symbolTip1: 'Once created, it cannot be modified!',
    symbolTip2: 'Once created, it cannot be modified!',
    symbolTip3: 'When the mark price deviates from the index price by more than this value, take a reasonable price as the mark price.',
    symbolTip4: 'Optional deep aggregation in the order book.',
    symbolTip5: 'In order to prevent accidental losses caused by users entering the wrong prices.',
    symbolTip6: 'The minimum order quantity for a single limit order or market order.',
    symbolTip7: 'The minimum value of a single order, in margin currency.',
    symbolTip8: 'The maximum counts for a market order.',
    symbolTip9: 'The minimum value of a market order, in margin currency.',
    symbolTip10: 'The maximum counts for a limit order.',
    symbolTip11: 'The minimum value of a limit order, in margin currency.',
    symbolTip12: 'It is the maximum number of orders held on each contract at the same time, and there is no such limit after the market maker sets it in KV.',
    symbolTip13: 'If the mark price deviates from the index price by more than the set ratio, the fair price will be used as the mark price.',
    baseParams: 'Once created, it cannot be modified!',
    depthCheckedError: 'Please select order book deep aggregation',
    contractMerchantId: "Contract ID plus Merchant ID",
    companyId: 'SAAS Merchant ID',
    sumCloseVolume: 'Total closed positions(Contract)',
    liquidationVolume: 'Qiangping Quantity(Contract)',
    mergeVolume: 'Total consolidated amount of Qiangping(Contract)',
    contractCloud: 'Contract Cloud',
    date: 'Date',
    adminTxt1: 'Merchant Admin',
    adminTxt2: 'Platform Admin',
    adminTxt3: 'Super Admin',
    insuranceOverview: 'Overview',
    insuranceStatement: 'Statement',
    feePlatform: 'Platform',
    feeMerchant: 'Merchant',
    saasID: 'Merchant SaaS ID',
    minOrderMoneyNew: 'Order Value precision',
    minOrderMoneyNewTip: 'Order value precision, fill in the example: 1, 0.1, 0.01.',
    Competition: 'Competition',
    ActivityConfig: 'Activity Configuration',
    ActivityAdd: 'Add',
    ActivityEdit: 'Edit',
    DataMaintenance: 'Data Maintenance',
    ActivityData: 'Activity Data',
    BasicConfig: 'Basic Configuration',
    ActivityStatus: 'Status',
    Unstarted: 'Unstarted',
    Progressing: 'Progressing',
    Ended: 'Ended',
    Online: 'Online',
    Yes: 'Yes',
    No: 'No',
    ActivityID: 'Activity ID',
    ActivityName: 'Activity Name',
    ActivityType: 'Type',
    TradingAndROE: 'Trading Amount & ROE',
    TradingAmount: 'Trading Amount',
    Roe: 'ROE',
    ActivityTime: 'Activity Time',
    Participants: 'Participants',
    EstimatedWinner: 'Estimated winner',
    Bonus: 'Bonus(USDT)',
    BonusRecovery: 'Bonus Recovery(USDT)',
    UpdateTime: 'Update time',
    Note: 'Note: This data is mainly used to display the current number of participants on the Client, the number of people displayed on the client-side = the actual number of people + the number of people increased based on the data + the number of people maintaining the ranking.',
    RankMaintenance: 'Rank Maintenance',
    CreateUser: 'Create a User',
    UserEmail: 'User Email',
    EmailFormat: 'Please fill in the correct email format.',
    Information: 'Please complete the user information.',
    ActivityNameErr: 'Please fill in the activity name',
    ActivityTimeErr: 'Please select the activity time',
    ActivityTypeErr: 'Please select an activity type',
    StartTime: 'Start Time',
    EndTime: 'End Time',
    actInfo: 'After launch, the activity page will display activity information, update leaderboards, and issue bonuses.',
    actInfo2: 'After going offline, the event page will not display activity information, update leaderboards, or issue bonuses.',
    actInfo3: 'At most one activity can be launched. There are currently other activities already launched.',
    Participation: 'Participation Criteria',
    Kyc: 'Complete KYC',
    BindPhone: 'Bind Phone',
    FuturesAccount: 'Futures Account Equity>=',
    RankingRules: 'Award Eligibility',
    TradingCompetition: 'Trading Volume Competition',
    ROECompetition: 'PNL% Competition',
    Participate: 'Only users who meet the conditions of the ranking rules can participate in the ranking and share the bonus pool.',
    Cumulative: 'Cumulative Trading Amount',
    OpeningTimes: 'Valid Opening Times',
    BonusSetting: 'Bonus Settings',
    Respective: 'The top 3 setting values are the respective bonus amounts of the top three; the 4th tier bonus is set to be the bonus amount shared by users; the participation award is shared by all ranked users after the 4th tier ranking.',
    No1: '1st Prize',
    No2: '2nd Prize',
    No3: '3rd Prize',
    No4: '4th',
    ParticipationAward: 'Participation Award',
    TotalBonus: 'Total Bonus',
    Distribution: 'Bonus Distribution & Recovery',
    Recovery: 'Bonus form',
    bonus: 'Futures bonus',
    No1Err: '[0-999999999], integer',
    Company: 'Company contract bonus account balance',
    insufficient: 'The current balance is insufficient.',
    insufficient2: 'Check the recharge guide.',
    DistributionTime: 'Bonus distribution time',
    RecoveryTime: 'Bonus recovery time',
    ActivityRuleErr: 'Please select the entry criteria',
    ActivityRuleNumErr: 'Please enter the contract account equity',
    ruleVolumeErr: '[0-999999999.99], up to 2 decimal places',
    ruleRoeErr: '[-100-9999.99], up to 2 decimal places',
    ruleOpenNumErr: '[0-10000], integer',
    ruleOpenNumUnit: 'Times',
    bounsStartTime: 'Please select the time for gift distribution',
    bounsEndTime: 'Please select the collection time for the gift',
    ActivityPageLink: 'Activity Page Link',
    CopyLink: 'Copy link',
    Copy: 'Copy succeeded',
    ActivityPageBanner: 'Activity Page Banner',
    Upload: 'Upload',
    ImageFormat: 'Image Format',
    CopyLinkImg: 'size no larger than',
    GameRulesLink: 'Competition Rules Link',
    PleaseEnterLink: 'Please enter link',
    ActivityDescription: 'Activity Description',
    Description: 'Competition Rules Link',
    Description2: 'Does not meet the filling rules, please fill in the link address.',
    imgRuleWeb: '(Image Format：size no larger than 5M，2560*480 px，JPG/PNG/JPEG）',
    imgRuleH5: '(Image Format：size no larger than 5M，375 *420 px，JPG/PNG/JPEG）',
    ActivityDescriptionTxt: 'Please enter a description of the activity',
    RankType: 'Competition Type',
    CurrentRank: 'Current Ranking',
    ExpectedRewardAmount: 'Expected reward amount',
    tradeAmountUsdt: 'Trading Amount (USDT)',
    RoeAmountUsdt: 'PNL(%)',
    RegistrationTime: 'Registration Time',
    baseData: 'Based on the data, increase',
    people: 'People',
    ParticipantsErr: 'Please enter the number of participants',
    TopPeople: 'Configure virtual users, who will participate in user ranking based on the configured transaction volume or yield. When bonus payments are made, virtual users will not be paid, and a maximum of 20 users can be configured.',
    addUser: 'Create a User',
    TradingAmountErr: 'The activity is in progress, and the transaction amount must be greater than or equal to the previous value',
    coAccountBalanceErr: 'Insufficient balance in the contract gift account, please recharge first',
    bounsStartTimeErr: 'The gift distribution time needs to be later than the end time of the event',
    bounsEndTimeErr: 'The gift collection time needs to be later than the gift distribution time',
    imgRuleErr: 'Does not meet the image rules, please upload again.',
    noticeContentErr: 'Please enter a description of the activity, up to 5000 characters (optional).',
    userTxt: 'User',
    sort2: 'Prize',
    userUidErr: 'Please enter the user UID',
    required: 'Please fill in all required fields correctly.',
    ruleOpenNumErr2: '[4-10000], integer',
    actStartTimeErr: 'The start date of the activity must be earlier than the end date',
    BonusTxt: 'Bonus',
    withLink: 'with link',
    withOutLink: 'without link',
    Prerequisite: 'Prerequisite',
    HasLogged: 'Has logged',
    Cumulative2: 'Cumulative trading amount >=',
    displayTimes: 'The max display times',
    displayTimesTip: 'The bulletin will be displayed once a day and the times of bulletin + 1. The times of bulletin must be less than or equal to the max display times.',
    MerchantShow: 'Merchants',
    noteLan: 'Language',
    Bulletin: 'Bulletin Content',
    noteUrl: 'URL',
    noteStatus: 'Status',
    noteOpen: 'After saving, the configured content will be displayed on the client. Do you want to save it?',
    noteClose: 'After saving, the bulletin will not be displayed on the client, and the times of the bulletin will be cleared. Do you want to save it?',
    noteErr: 'Only positive integers can be filled in',
    noticeContentErr2: 'Please enter bulletin content, up to 500 characters.',
    "adtv": "ADTV",
    "UserRank": "User Ranking",
    "DailyAverage": "Daily Average",
    "Allcontract": "All contracts",
    "IncompleteFilled": "Incomplete Filled",
    "CompleteFilled": "Complete Filled",
    "Cancelled": "Cancelled",
    "Abnormal": "Abnormal",
    "UserAnalytics": "User Analytics",
    "newUsers": "New users daily",
    "NewFuturesUsers": "New Futures Users",
    "ActiveUsers": "Active Users",
    "ActiveUsersTip": "The number of users who have positions or have traded during the selected time period.",
    "NewToday": "New Today",
    "NewMonth": "New This Month",
    "EffectiveUsers": "Effective Users",
    "EffectiveUsersTip": "As of now, the number of users whose assets in the contract account are not 0.",
    "TotalFuturesUsers": "Total Futures Users",
    "NewLastMonth": "New Last Month",
    "NewYesterday": "New Yesterday",
    "MoM": "MoM",
    "DoD": "DoD",
    "MerchantTotal": "Merchant",
    "DailyStatement": "Daily Statement",
    "Excludemerchants": "Exclude merchants with 0 total users",
    "Excludemerchants2": "Exclude merchants with 0 new users",
    "MerchantNew": "Merchant",
    "TotalBalance": "Real-time Total Balance",
    "newUid": "UID",
    "UserDetails": "User Details",
    "CreateTime": "Create Time",
    "TotalBalanceNew": "Total Balance",
    "TradingVolume": "Trading Volume",
    "WinningRate": "Winning Rate",
    "newLateTrade": "Latest Trade",
    "newContract": "Contract",
    "manualClose": "Manual Closing",
    "newPnl": "PnL",
    "closingTimeNew": "Latest Closing",
    "CompleteFilledNew": "Complete Fill",
    "otherNew": "Others",
    "posNew": "Positions",
    "leverageLevelNew": "Leverage",
    "Merged": "Merged",
    "Liquidated": "Liquidated",
    "IncompleteFilledNew": "Incomplete Fill",
    "Direction": "Direction",
    "positionParamNew": "Parameters",
    "entrustVolume": "Amount",
    "feeNew": "Fee",
    "ConditionType": "Condition Type",
    "ADLRecord": "ADL Record",
    "PositionID": "Liquidation Position ID",
    "entrustID": "Delegate ID",
    "ClosingPnL": "Closing PnL",
    "UnrealizedPnL": "Unrealized PnL",
    "BankruptcyPrice": "Bankruptcy Price",
    "achievedAmountNew": "Takeover PnL",
    "IFCompensation": "IF Compensation",
    "riskProfit": "IF PnL",
    "isADL": "Whether ADL",
    "ADLQuantity": "ADL Quantity (Cont.)",
    "newUser": "User",
    "ADLPrice": "ADL Price",
    "Totalequity": "Total Balance",
    "TotalequityTip": "Total Balance = Wallet Balance + Unrealized PnL",
    "WalletBalance": "WalletBalance",
    "WalletBalanceTip": "Settled balace, excluding unrealized pnl.Wallet Balance = Total Net Transfer + Total Realized PnL + Total Net Funding Fee - Total Commission",
    "UnrealizedPnLTip": "Unrealized profit & loss is calculated based on mark price",
    "CrossMargin": "Cross Margin Account",
    "AvailableNew": "Available",
    "ADL": "ADL",
    "Userfees": "Fee",
    "Userdiscount": "User Discount",
    "DiscountRestrictions": "Discount Limit",
    "feeNewUser": "New Users",
    "Allusers": "All Users",
    "singleUser": "Single User",
    "condition": "Condition",
    "conditionTip": "Registered users can only enjoy the fee discount within the set period",
    "periodDate": "Validity Period",
    "periodDateTip": "Only transactions within the discount validity period can enjoy the fee discount.",
    "feeDiscount": "Fee Discount",
    "feeDiscountTip": "Please enter the fee discount rate",
    "feeDiscountMax": "The maximum value is {feeDiscountMax}",
    "addTime": "Add time",
    "Registrationtime": "Registration time",
    "RegistrationtimeTip": "Only new users who register after the registration time can enjoy the fee discount.",
    "RegistrationtimeTip2": "Fee rate = initial fee rate * (1- fee discount)",
    "RegistrationtimError": "Please select registration time",
    "conditionError": "Please enter an integer in the range [1, 99999]",
    "regAfter": "Within",
    "dayAfter": "days after registration",
    "actStartTimeErr2": "Start time must be less than end time",
    "periodDateErr": "Please select validity period",
    "discountPeriodDate": "Validity Period",
    "UidErr": "Please input UID",
    "newFeeMax": "Max new users fee discount（%）",
    "newFeeMax2": "Max new users fee discount",
    "newFeeMaxTip": "Please enter the fee discount rate",
    "allUserFeeMax": "Max all users fee discount（%）",
    "allUserFeeMax2": "Max all users fee discount",
    "feeFwErr": "Exceeds the input range",
    "regAfter2": "Within",
    "dayAfter2": "days after registration",
    "addUserDiscount": "Add User Discount",
    "editUserDiscount": "Edit User Discount",
    "InputRange": "Input range",
    "infoErr": "The information is incomplete, please fill in all information.",
    "maxUserLimit": "Max single user fee discount（%）",
    "maxUserLimit2": "Max single user fee discount",
    "transferInNew": "When sorting by inflow, users whose inflow and outflow are 0 will not be displayed.",
    "transferOutNew": "When sorting by outflow, users whose inflow and outflow are 0 will not be displayed.",
    "updateDataTime": "The data on this page was updated on",
    "Invitefriends": "Invite friends",
    "InviteCode": "Invitation code",
    "AgentRole": "Role",
    "Rebateratio": "Rebate rate",
    "RebateratioSub": "Subordinate rebate level",
    "RebateratioTip": "After your subordinate trades, you will receive part of the handling fee.",
    "Rebateratiocash": "Shared rate",
    "RebateratiocashTip": "After your direct subordinate trades, the trader will be given a share of the handling fee.",
    "RebateratioLever": "Highest rebate level",
    "agentChange": "Change",
    "Datascreening": "Data Overview",
    "directNum": "Direct subordinates",
    "directNumAll": "Total subordinates",
    "directNumAllTip": "The total number of subordinates who can give you commission rebates.",
    "directNumDown": "Sub-affiliates",
    "directNumDownTip": "Number of affiliates in total subordinates.",
    "directAmount": "Subordinate trading volume(USDT)",
    "directAmountTip": "Total subordinate futures trading volume, non-U tokens are converted into USDT according to the exchange rate at the time of statistics, including opening and closing positions, excluding mock contracts.",
    "directMy": "My rebate(USDT)",
    "directMyChart": "My daily rebate(USDT)",
    "directMyTip": "The Futures rebate you receive，non-U tokens are converted into USDT according to the exchange rate at the time of statistics.",
    "RebateratiocashMax": "Please enter two decimal places in the range of {feeDiscountMin}～{feeDiscountMax}%",
    "RebateratiocashMaxTip": "{feeDiscountMin}～{feeDiscountMax}",
    "RebateratiocashTip2": "It cannot be higher than the 1st rebate rate of the current role.",
    "invitedUsers": "Invited Users",
    "invitedUsersTip": "Number of users who registered through invitation codes",
    "TotalNumberUsers": "Total Users",
    "contractBrokeNum": "Futures Affiliates",
    "commissionRebates": "Cumulative Issued Rebates(USDT)",
    "commissionRebatesTip": "The total amount of futures rebates issued to affiliates, and non-U tokens are converted into USDT according to the exchange rate at the time of statistics",
    "agentType0": "Proportion",
    "agentType1": "Differential",
    "agentType2": "Fixed spread",
    "ReturnedCommission": "Rebate recipient",
    "ReturnedCommissionTip": "People who receive rebates",
    "ReturnedCommissionUid": "Referrer UID",
    "ReturnedCommissionUid2": "Referrer UID",
    "ReturnedCommissionMy": "Me",
    "ReturnedCommissionThe": "Others",
    "ReturnedCommissionLevel": "Rebate level",
    "ReturnedCommissionLevelTip": "Rebate levels according to rebate recipient",
    "Receivedcommission": "Received rebates",
    "ReceivedcommissionTip": "Including self-rebate",
    "ReceivedcommissionAmount": "Trading volume",
    "ReceivedcommissionAmountTip": "The total future trading volume of users with selected rebate levels. Non-U tokens are converted into USDT according to the exchange rate at the time of statistics, including opening and closing positions, excluding mock contracts.",
    "ReceivedcommissionNum": "Number of trades",
    "ReceivedcommissionNumTip": "The total number of futures tradings for users with the selected rebate level. Non-U tokens are converted into USDT according to the exchange rate at the time of statistics. Multiple tradings of the same order are counted as one trading. The time is based on the submission time, including opening and closing positions, excluding mock contracts.",
    "PID": "PID",
    "UIDTip": "The user who trades then contributes rebates to the rebate recipient.",
    "PIDTip": "Parent ID",
    "ReceivedcommissionAmountTip2": "During the selected time, the total futures trading volume of the user, and non-U tokens are converted into USDT according to the exchange rate at the time of statistics.",
    "CommissionRebate": "Rebate",
    "CommissionRebateTip": "During the selected time, the total rebates given by the user to the rebate recipient, and non-U tokens are converted into USDT according to the exchange rate at the time of statistics.",
    "agentFee": "Handling fee",
    "agentFeeTip": "During the selected time, the total futures handling fees of the user, and non-U tokens are converted into USDT according to the exchange rate at the time of statistics.",
    "Rebatedetail": "Details",
    "RebateStatus": "Rebate status",
    "RebateStatusTxt1": "Unissued",
    "RebateStatusTxt2": "Freezing",
    "RebateStatusTxt3": "Recycled",
    "RebateStatusTxt4": "Issued",
    "RebateRate": "Rebate rate",
    "RebateRateTip": "The rebate rate of the rebate recipient at the trader’s rebate level",
    "marginCoin": "Margin token",
    "searchUidTip": "People who trade and generate rebate",
    "returnAmount": "Rebate amount",
    "returnAmountTip": "Differential broker’s rebate amount = handling fee * rebate rate – rebate that has been sent to subordinates",
    "agentEmail": "Email",
    "agentPhone": "Phone",
    "isKYC": "KYC",
    "yes": "Yes",
    "no": "No",
    "isContract": "Futures activation",
    "isInContract": "Futures deposit",
    "isTradeContract": "Futures trading",
    "openContractTime": "Activate futures time",
    "agentEmaiPhone": "Email/Phone",
    "pidTip2": "Parent ID",
    "Region": "Region",
    "agentKey": "Key",
    "agentValue": "Value",
    "agentDesc": "Description",
    "agentDescErr": "Please enter a description",
    "agentAccount": "Affiliate Rewards Account",
    "Transfer": "Transfer",
    "agentAccountTip": "When the account balance reaches 0, the system will suspend the affiliates' rebates.",
    "agentRatio": "Direct referral rate",
    "agentRatioSet": "Direct referral rate setting",
    "explain": "Note:",
    "explainTip1": "1. This page sets the referral rebate rate of ordinary users(not brokers) who recommend friends.",
    "explainTip2": "2. If this amount is configured as 0, commission rebates for ordinary users will not be supported.",
    "agentSet": "Set",
    "agentBalance": "(balance:{balance})",
    "agentRoleName": "Role",
    "Freeze": "Freeze",
    "Unfreeze": "Unfreeze",
    "Delete": "Delete",
    "FreezeTip": "After freezing, the broker's rebates will be included in the calculation but will not be distributed. Are you sure you want to freeze this broker?",
    "UnfreezeTip": "After unfreezing, any rebates that have not been released during the freezing period will be sent to the broker. Are you sure you want to unfreeze this broker?",
    "DeleteTip": "After deletion, the broker will no longer enjoy commission rebates. Are you sure you want to delete this broker?",
    "addBroker": "Add broker",
    "editBroker": "Edit broker",
    "userInfo": "User info",
    "roleName": "Role name",
    "Sharetype": "Share type",
    "Creationtime": "Creation time",
    "Brokersincluded": "Affiliates included",
    "deleteRole": "Are you sure to delete this role?",
    "returnTypeTip1": "If A and B's first-level rebate rate is 60%; the second-level rebate rate is 40%;User C generates a handling fee10 USDT Case1：Invitation Relationship: A-->B-->C Rebate: C-->B：6 USDT； C-->A:4 USDT Case2：Invitation Relationship: B-->C    (No indirect invitees) Rebate: C-->B：6 USDT",
    "returnTypeTip2": "If A's rebate rate is 60%, B's rebate rate is 40% User C generates a handling fee10 USDT Case1：Invitation Relationship: A-->B-->C Rebate: C-->B：4 USDT； C-->A:2 USDT Case2：Invitation Relationship: B-->C    (No indirect invitees) Rebate: C-->B：4 USDT",
    "returnTypeTip3": "This type of broker's subordinate share is divided according to the set ratio.",
    "agentLevel": "Level",
    "agentLevelErr": "Please enter a number between 0~99.99",
    "deleteAgent": "The number of brokers contained in the current role is not 0 and cannot be deleted!",
    "addRole": "Add Role",
    "editRole": "Edit Role",
    "futuresBroker": "Futures Affiliate",
    "confirm": "Confirm",
    "noLogin": "Login has expired!",
    "brokerRewardAccount": "Company: (Spot & Futures) Agent Rewards Account",
    "googleCodeTip": "Please go to the futures admin system to bind the Google verification code!",
    "searchType": "Search Type",
    "agentSpot": "Spot",
    "agentFutures": "Futures",
    "tradeTime": "Trading date",
    "agentTit": "Affiliate",
    "agentDownNum": "Direct subordinates",
    "agentTeamNum": "Team size",
    "agentInMoneyNum": "People have deposited",
    "agentTradeNum": "People have traded",
    "agentTotalassetU": "Total assets(USDT)",
    "agentInflowU": "Inflow(USDT)",
    "agentOutflowU": "Outflow(USDT)",
    "agentCurrentPositionU": "Position amount (USDT)",
    "agentTransactionVolumeU": "Trading amount (USDT)",
    "agentFeeU": "Handling fee(USDT)",
    "agentReturnU": "Rebate (USDT)",
    "agentBreadTit": "Direct subordinates",
    "dayNewUnderDownLevel": "New direct subordinates daily",
    "dayNewDownLevel": "New subordinates daily",
    "dayNewDownLevelAgent": "New sub-affiliate daily",
    "dayNewDownLevelTrade": "Subordinates daily trading amount (USDT)",
    "overInvitedUsers": "New invited users daily",
    "overAddAgentUsers": "New futures affiliates daily",
    "overReturn": "Daily issued rebates (USDT)",
    "settlementTime": "Settle time",
    "totalContracAssets": "Total futures assets",
    "agentInflow": "Inflow",
    "agentOutflow": "Outflow",
    "agentIncome": "PNL",
    "agentTransfer": "Transfer",
    "agentGrant": "Issue",
    "agentUidAccount": "UID/Account",
    "notInviteNum": "Do not display affiliates with 0 subordinate",
    "notInviteNumTwo": "Do not display users with 0 invitations",
    "totalContracAssetsTip": "The current assets in the futures account, total future assets = wallet balance + unrealized PNL",
    "WalletBalanceTip": "The current wallet balance of the futures account, wallet balance = balance account + isolated margin + frozen margin",
    "agentInflowTip": "Assets transferred to the futures account within the selected period",
    "agentOutflowTip": "Transfer assets from the futures account within the selected period",
    "agentIncomeTip": "The PNL of the futures account during the selected period",
    "agentReturnLevelTip": "What level is the user of the affiliate?",
    "agentDownNumTip": "Currently, the number of people directly invited by the sub-affiliate",
    "agentTeamNumTip": "At the latest script statistics, the number of people within the rebate range of the sub-affiliate",
    "agentInMoneyNumTip": "The number of people transferred from spot to futures within the time and the sub-affiliate rebate range.",
    "agentTradeNumTip": "The number of people who have had one futures trade within the time and the sub-affiliate rebate range.",
    "agentTotalassetUTip": "At the latest script statistics, the total team assets, and non-U tokens are converted into USDT, including cross margin, isolated margin, frozen margin and unrealized PNL.",
    "agentInflowUTip": "The total amount transferred to the futures account within the time and the sub-affiliate rebate range. Non-U tokens are converted into USDT, including futures bonuses.",
    "agentOutflowUTip": "The total amount transferred from the futures account within the time and the sub-affiliate rebate range. Non-U tokens are converted into USDT, including futures bonuses.",
    "agentCurrentPositionUTip": "According to the latest script statistics, the position amount is the sum of user position values within the time and the sub-affiliate rebate range, and non-U tokens are converted into USDT.",
    "agentTransactionVolumeUTip": "The total trading volume of the team  within the time and the sub-affiliate rebate range; including opening and closing positions, excluding simulated contracts; non-U tokens are converted into USDT.",
    "agentFeeUTip": "The total handling fees generated by total user within the time and the sub-affiliate rebate range; non-U tokens are converted into USDT.",
    "agentReturnUTip": "The sum of rebates received by sub-affiliates within the time; non-U tokens are converted into USDT.",
    "agentOrderNum": "Order number",
    "transferOut": "Transfer Out",
    "entrustedValue": "Entrusted value",
    "transferToCo": "Spot to futures account",
    "transferOutCo": "Futures to spot account",
    "roleTypeNote": "Note: When configuring this role, pay attention to the total rebate ratio for multiple tiers.",
    "agentOperationPermissionTip": "Enabling this allows the broker to add sub-brokers and manage them (role editing, freezing, deletion). Disabling it hides these operation buttons from the broker in the client.",
    "noAgentOperationPermission": "The current role has no permission for this operation.",
    "rebateStatusTip1": "Unissued: Rebate data that has been counted but not yet issued.",
    "rebateStatusTip2": "Freezing: Rebate data that has been counted but not yet issued due to the broker being frozen.",
    "rebateStatusTip3": "Issued: Rebate data that has been counted and issued.",
    "rebateStatusTip4": "Recycled: The rebate was frozen, and it will no longer be issued after the broker is deleted.",
  },
  "editInvitationCode": {
    "customCode": "Custom invitation codes",
    "originalCode": "Original Invitation Code",
    "newCode": "New Invitation Code",
    "placeholder": "6 - 9 uppercase letters or numbers",
    "errotText": "Please enter 6 - 9 uppercase letters or numbers.",
    "errotText2": "Do not match the original invitation code",
    "note": "Note: After the invitation code is successfully modified, the invitation link will be updated synchronously. The old invitation code and invitation link will become invalid.",
    "emailTip": "Send email reminder"
  },
  "returnLevel": {
    "t1": "Rebate Level",
    "t2": "Merchant",
    "t3": "Status",
    "t4": "Highest rebate level",
    "t5": "Add Time",
    "t6": "Update Time",
    "t7": "Operation",
    "t8": "Please enter highest rebate level",
    "t9": "Opened",
    "t10": "Closed",
    "t11": "Add",
    "t12": "Edit",
    "t13": "Save",
    "t14": "Cancel",
    "t15": "Search",
    "t16": "Reset"
  },
  "walletBonus": {
    "t1": "Self-rebate"
  }
};
